
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getPagedTemplates = (pagingRequest, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/AuctionTemplates/GetPagedTemplates`, pagingRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getTemplateTiers = (adminAuctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/AuctionTemplates/GetAuctionTemplateTiers/` + adminAuctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getAuctionTemplateViewModel = (sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/AuctionTemplates/GetAuctionTemplateViewModel`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const modifyTemplate = (auctionTemplate, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/AuctionTemplates/ModifyTemplate`, auctionTemplate, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addTemplate = (auctionTemplate, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/AuctionTemplates/AddTemplate`, auctionTemplate, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const deleteTemplate = (adminAuctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.delete(`${Environment.apiUrl}/AuctionTemplates/DeleteTemplate/` + adminAuctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const createTemplateAuction = (adminAuctionId, vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/AuctionTemplates/CreateTemplateAuction/${adminAuctionId}/${vehicleId}`, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const AuctionTemplatesService =
{
	getPagedTemplates,
	getTemplateTiers,
	getAuctionTemplateViewModel,
	modifyTemplate,
	addTemplate,
	deleteTemplate,
	createTemplateAuction
}

export default AuctionTemplatesService
